module.exports = __webpack_public_path__ + "static/media/filter_collapsed.06500b53.svg";